// Pure gate predicates for the NPC market tab — extracted from
// market-npc-tab.ts so they can be unit-tested without pulling in the
// Pixi-importing render code.
//
// Phase 7 Block A — playtest finding 9.6 ("NPC sell button never enabled")
// turned out to be a downstream effect of the spinner runaway (9.3): qty
// climbed past inventory count, "no_inventory" disabled the row. Lifting
// these into their own file keeps the regression directly testable from
// server/src/npc-tab-gates.test.ts (which can't import Pixi).

import { getNpcItem } from "../../shared/npc-items.ts";
import type { NpcInventory, NpcPriceEntry } from "../../shared/market.ts";
import type { InventorySlot } from "../../shared/messages.ts";

export type NpcGateSnapshot = {
  npcInventory: NpcInventory;
  playerInventory: readonly InventorySlot[];
  playerCredits: number;
};

export function computeNpcBuyDisable(
  entry: NpcPriceEntry,
  qty: number,
  snap: NpcGateSnapshot,
): "out_of_stock" | "insufficient_credits" | null {
  const stock = snap.npcInventory[entry.itemId] ?? 0;
  if (stock < qty) return "out_of_stock";
  if (snap.playerCredits < entry.sellPrice * qty) return "insufficient_credits";
  return null;
}

export function computeNpcSellDisable(
  entry: NpcPriceEntry,
  qty: number,
  snap: NpcGateSnapshot,
): "no_inventory" | "npc_saturated" | null {
  const playerHas = snap.playerInventory.find((s) => s.itemId === entry.itemId)?.count ?? 0;
  if (playerHas < qty) return "no_inventory";
  const cfg = getNpcItem(entry.itemId);
  const stock = snap.npcInventory[entry.itemId] ?? 0;
  if (cfg && stock + qty > cfg.maxInv) return "npc_saturated";
  return null;
}
